<template>
  <div class="row">
    <b-form-group
        id="formgroup-firstField"
        :label="$t('condition_result_range.form.fields.condicao.fields.firstField.label')"
        :description="this.showDescription ? $t('condition_result_range.form.fields.condicao.fields.firstField.description') : ''"
        label-for="condition_result_range-firstField"
        class="col-md-3"
        required
    >
      <b-form-select v-model="form.firstField" :options="DB_fields" v-on:change="onChangeField"/>
    </b-form-group>
    <b-form-group
        id="formgroup-rule"
        :label="$t('condition_result_range.form.fields.condicao.fields.rule.label')"
        :description="this.showDescription ? $t('condition_result_range.form.fields.condicao.fields.rule.description') : ''"
        label-for="name-rule"
        class="col-md-3"
        required
    >
      <b-form-select v-model="form.regra" :options="rules" v-on:change="onChangeRule"/>
    </b-form-group>
    <b-form-group
        v-if="showSecondField"
        id="formgroup-secondField"
        :label="$t('condition_result_range.form.fields.condicao.fields.secondField.label')"
        :description="this.showDescription ? $t('condition_result_range.form.fields.condicao.fields.secondField.description') : ''"
        label-for="condition_result_range-secondField"
        :class="needTwoFieldsClass"
    >
      <b-form-input v-model="form.secondField" v-on:change="onChangeSecondField"/>
    </b-form-group>
    <b-form-group
        v-if="needTwoFieldsBoolean"
        id="formgroup-thirdField"
        :label="$t('condition_result_range.form.fields.condicao.fields.thirdField.label')"
        :description="this.showDescription ? $t('condition_result_range.form.fields.condicao.fields.thirdField.description') : ''"
        label-for="condition_result_range-thirdField"
        :class="needTwoFieldsClass"
    >
      <b-form-input v-model="form.thirdField" v-on:change="onChangeThirdField"/>
    </b-form-group>
    <b-form-group
      v-if="showFourthField"
        id="formgroup-fourthField"
        :label="$t('condition_result_range.form.fields.condicao.fields.fourthField.label')"
        :description="this.showDescription ? $t('condition_result_range.form.fields.condicao.fields.fourthField.description') : ''"
        label-for="condition_result_range-fourthField"
        :class="needTwoFieldsClass"
    >
      <b-form-input v-model="form.fourthField" v-on:change="onChangeFourthField"/>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "ConditionResultRange",
  props: {
    form: {
      index: {
        Number,
        default: 0
      },
      firstField: {
        String,
        default: null
      },
      regra: {
        String,
        default: null
      },
      secondField: {
        String,
        default: null
      },
      thirdField: {
        String,
        default: null
      },
      fourthField: {
        String,
        default: null
      }
    },
    showDescription: {
      Boolean,
      default: true
    }
  },
  data() {
    return {
      DB_fields: [        
        {value: 'value_quantity_value', text: this.$t('condition_result_range.form.fields.condicao.DB_fields.value_quantity_value')}        
      ],
      rules: [
        {value: 'IS NULL', text: this.$t('condition_result_range.form.fields.condicao.rules.isNull'), requireSecondField: false},
        {
          value: 'IS NOT NULL',
          text: this.$t('condition_result_range.form.fields.condicao.rules.isNotNull'),
          requireSecondField: false
        },
        {value: '>', text: this.$t('condition_result_range.form.fields.condicao.rules.bigger'), requireSecondField: true},
        {value: '>=', text: this.$t('condition_result_range.form.fields.condicao.rules.biggerOrEqual'), requireSecondField: true},
        {value: '<', text: this.$t('condition_result_range.form.fields.condicao.rules.less'), requireSecondField: true},
        {value: '<=', text: this.$t('condition_result_range.form.fields.condicao.rules.lessOrEqual'), requireSecondField: true},
        {value: '==', text: this.$t('condition_result_range.form.fields.condicao.rules.equal'), requireSecondField: true},
        {value: '!=', text: this.$t('condition_result_range.form.fields.condicao.rules.different'), requireSecondField: true},
        {value: 'BETWEEN', text: this.$t('condition_result_range.form.fields.condicao.rules.between'), requireSecondField: true},
        {value: 'NOT BETWEEN', text: this.$t('condition_result_range.form.fields.condicao.rules.notBetween'), requireSecondField: true}
      ],
      needTwoFieldsClass: 'col-md-3',
      needTwoFieldsBoolean: false,
      showSecondField: true,
      showFourthField: true
    }
  },
  methods: {
    onChangeRule() {
      if (this.form.regra === 'NOT BETWEEN' || this.form.regra === 'BETWEEN') {
        this.needTwoFieldsClass = 'col-md-2'
        this.needTwoFieldsBoolean = true
        return
      }
      this.needTwoFieldsClass = 'col-md-3'
      this.needTwoFieldsBoolean = false

      this.$emit('change', this.form)
    },
    onChangeField() {
      this.$emit('change', this.form)
    },
    onChangeSecondField() {
      this.$emit('change', this.form)
    },
    onChangeThirdField() {
      this.$emit('change', this.form)
    },
    onChangeFourthField() {
      this.$emit('change', this.form)
    },
  },
  mounted() {
    this.onChangeRule()
  }
}
</script>

<style scoped>

</style>
